import { z } from "zod";

export const formSchema = z.object({
  companyName: z.string().min(1, "Company name is required"),
  teamSize: z.string().min(1, "Team size is required"),
  contactName: z.string().min(1, "Contact name is required"),
  role: z.string().min(1, "Role is required"),
  email: z.string().email("Please enter a valid email address"),
  phone: z.string().min(1, "Phone number is required"),
  currentSystems: z.string().min(1, "Current systems information is required"),
  integrationNeeds: z.string().min(1, "Integration needs are required"),
  preferredDate: z.string().min(1, "Preferred date is required"),
  budgetRange: z.string().min(1, "Budget range is required"),
});

export type FormData = z.infer<typeof formSchema>;